import { render } from "./index.vue?vue&type=template&id=0b4c3672&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0b4c3672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4c3672"]])

export default __exports__